var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageActive)?_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"src":_vm.config.imageUrl,"alt":""}}):_c(_vm.tag,{tag:"component"},[_vm._v(_vm._s(_vm.displayText))])
}
var staticRenderFns = []

export { render, staticRenderFns }